import React from 'react';
import { CONTRACTS, MEPC_JOBS } from './billingContract';
import msaThumb from '../assets/contracts/msa.jpg';
import blitzThumb from '../assets/contracts/so-blitz.jpg';
import pb4Thumb from '../assets/contracts/so-pb4.jpg';
import gs77Thumb from '../assets/contracts/so-gs77.jpg';

// The signed documents the VoltaGrid jobs bill under, as page-1 thumbnails
// above Rates & Rules on the Invoices view. Each opens the executed PDF where
// it is filed on SharePoint — the job site's 03 - Project Management /
// 03.01 - Contract folder — so access follows the viewer's own SharePoint
// permissions and no copy rides in the app.

// 54026077 General Services bills under its own blanket Service Order but
// isn't one of the jobs the contract billability rules govern.
const GS_JOBS = ['54026077'];
const DOC_JOBS = [...MEPC_JOBS, ...GS_JOBS];

const SITE = 'https://strikena.sharepoint.com/sites/2026Jobs';
const contractUrl = (job, file) => [SITE, job, 'Shared Documents', '03 - Project Management', '03.01 - Contract', file]
    .map((s, i) => (i ? encodeURIComponent(s) : s))
    .join('/') + '?web=1';

export const CONTRACT_DOCS = [
    {
        id: 'msa',
        title: 'MSA',
        sub: 'MEPC Agreement #101 · all jobs',
        meta: 'Effective Aug 31, 2026 · 114 pp',
        thumb: msaThumb,
        url: contractUrl('54026070', 'EXECUTION Version _Voltagrid-MEPC-STRIKE-2026 08 31.docx.pdf'),
    },
    {
        id: CONTRACTS.blitz.id,
        title: 'Service Order — Blitz',
        sub: `QPAC Blitz Acceleration · ${CONTRACTS.blitz.jobs.join(', ')}`,
        meta: 'Signed Sep 5, 2026 · 25 pp',
        thumb: blitzThumb,
        url: contractUrl('54026070', 'Execution Version_SO Blitz TX3_ Strike - VoltaGrid_09.04.docx (2) - 9-15-26.pdf'),
        jobs: CONTRACTS.blitz.jobs,
    },
    {
        id: CONTRACTS.pb4.id,
        title: 'Service Order — Block 4',
        sub: `Power Block 4, Frontier TX3 · ${CONTRACTS.pb4.jobs.join(', ')}`,
        meta: 'Signed Sep 26, 2026 · 31 pp',
        thumb: pb4Thumb,
        url: contractUrl('54026071', 'SO - TX3 Power Block 4_Strike VG Execution Version_09.24.docx.pdf'),
        jobs: CONTRACTS.pb4.jobs,
    },
    {
        id: 'gs',
        title: 'Service Order — Blanket',
        sub: `General Services, TX3 · ${GS_JOBS.join(', ')}`,
        meta: 'Signed Oct 17, 2026 · 25 pp',
        thumb: gs77Thumb,
        url: contractUrl('54026077', 'SO-VG-Strike Operating Company 261016 [Executed].docx.pdf'),
        jobs: GS_JOBS,
    },
];

const label = { fontSize: 9, color: '#94a3b8', fontWeight: 700, letterSpacing: 0.6 };

const BillingContractDocs = ({ jobKey }) => {
    const job = String(jobKey || '');
    if (!DOC_JOBS.includes(job)) return null;
    return (
        <div
            data-testid="contract-docs"
            style={{
                display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'stretch', columnGap: 12, rowGap: 10,
                marginBottom: 12,
            }}
        >
            {CONTRACT_DOCS.map((d) => {
                const mine = !!d.jobs?.includes(job);
                return (
                    <a
                        key={d.id}
                        href={d.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={`Open the signed ${d.title} on SharePoint`}
                        style={{
                            display: 'flex', flexDirection: 'row', alignItems: 'flex-start', textDecoration: 'none',
                            backgroundColor: '#ffffff', borderRadius: 6, borderStyle: 'solid', borderWidth: 1,
                            borderColor: mine ? '#94a3b8' : '#e2e8f0',
                            paddingTop: 8, paddingBottom: 8, paddingLeft: 8, paddingRight: 12,
                            width: 316, boxSizing: 'border-box', cursor: 'pointer',
                        }}
                    >
                        <img
                            src={d.thumb}
                            alt={`${d.title} page 1`}
                            style={{
                                width: 62, height: 80, objectFit: 'cover', objectPosition: 'top', flexShrink: 0,
                                borderStyle: 'solid', borderWidth: 1, borderColor: '#e2e8f0', borderRadius: 2,
                                boxShadow: '0 1px 2px rgba(15, 23, 42, 0.08)', backgroundColor: '#ffffff',
                            }}
                        />
                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10, minWidth: 0 }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', columnGap: 6, marginBottom: 3 }}>
                                <span style={{ fontSize: 13, fontWeight: 700, color: '#0f172a', whiteSpace: 'nowrap' }}>{d.title}</span>
                                {mine ? (
                                    <span
                                        title="The Service Order this job bills under"
                                        style={{
                                            ...label, color: '#334155', borderStyle: 'solid', borderWidth: 1, borderColor: '#cbd5e1',
                                            borderRadius: 3, paddingLeft: 4, paddingRight: 4, lineHeight: '13px', whiteSpace: 'nowrap', flexShrink: 0,
                                        }}
                                    >
                                        THIS JOB
                                    </span>
                                ) : null}
                            </div>
                            <span style={{ fontSize: 11, color: '#475569', marginBottom: 2, whiteSpace: 'nowrap' }}>{d.sub}</span>
                            <span style={{ fontSize: 10, color: '#94a3b8', marginBottom: 6, whiteSpace: 'nowrap' }}>{d.meta}</span>
                            <span style={{ fontSize: 11, color: '#2563eb', fontWeight: 600 }}>Open PDF ↗</span>
                        </div>
                    </a>
                );
            })}
        </div>
    );
};

export default BillingContractDocs;
